import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import OptimusButton from '../../common/library/Button/Button';

interface ConfidentialityModalProps {
  open: boolean;
  onClose: () => void;
}

export function ConfidentialityModal({ open, onClose }: ConfidentialityModalProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      PaperProps={{
        sx: {
          borderRadius: theme.spacing(1),
          boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
          margin: {
            xs: theme.spacing(2),
            sm: theme.spacing(4),
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2),
        }}
      >
        <Typography
          variant="headingMd"
          sx={{
            color: theme.palette.grey[900],
          }}
        >
          {t('coach.confidentialityLink')}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: theme.spacing(0, 3, 2, 3),
        }}
      >
        <Typography
          variant="bodyMd"
          sx={{
            color: theme.palette.grey[700],
            whiteSpace: 'pre-line',
          }}
        >
          {t('coach.confidentialityContent')}
        </Typography>
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: theme.spacing(2, 3, 3, 3),
        }}
      >
        <OptimusButton
          customVariant="primary"
          buttonText="CLOSE"
          size="m"
          fullWidth={false}
          minWidth={theme.spacing(12.5)}
          onClick={onClose}
        />
      </Box>
    </Dialog>
  );
}
